/* import __COLOCATED_TEMPLATE__ from './cancel-verification.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();